import { render, staticRenderFns } from "./goods-select.vue?vue&type=template&id=5d0c3615&scoped=true&"
import script from "./goods-select.vue?vue&type=script&lang=js&"
export * from "./goods-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0c3615",
  null
  
)

export default component.exports